module.exports = __webpack_public_path__ + "static/media/gestao_girl.96835daa.png";